import { Investor } from 'store/features/investors/types';
import axios from '../apiClient';
import { Society } from 'store/features/society/types';

type PaymentPayload = {
  amount: number,
  type: string,
  success_url: string,
  cancel_url: string,
  id_project: number,
  payment_method: string[],
  escrow_acct: string,
  pea: boolean,
  from_company: boolean,
  directly_in_society: boolean,
}

export const createPayment = (value: PaymentPayload) => axios.post(`/make-payment`, value);
export const getPaymentInfo = (reservation = 'reservation', iss: number, type: string, id: number) => {
  const url = new URL(`/payment/${reservation}`);
  if (iss) {
    url.searchParams.append('id_person', iss.toString());
  }
  if (type) {
    url.searchParams.append('type', type);
  }
  if (id) {
    url.searchParams.append('id_project', id.toString());
  }
  return axios.get(url.href);
}

export const redirectToSignature = (id: number) => {
  const params = new URLSearchParams(window.location.search);
  const id_transaction = params.get('id_transaction') || window.localStorage.getItem('id_transaction');
  const value = {
    id_transaction: id_transaction,
    success_url: `${window.location.origin}/${id}/confirmation/success`,
    cancel_url: `${window.location.origin}/${id}/confirmation/error`,
  };
  return axios.post(`/loi/${id}`, value);
};

export const getUserInfoById = (id: number) => axios.get(`/person/${id}`);
export const updateUserInfoById = (id: number, value: Investor) => axios.put(`/person/${id}`, value);
export const createUserInfo = (value: Investor) => axios.post(`/person`, value);

export const postUserFile = (formData: FormData, id: number) => axios.post(`/file${(id) ? `?iss_person=${id}` : ''}`, formData);
export const updateUserFile = (type: string, formData: FormData, id: number) => axios.put(`/file/${type}${(id) ? `?iss_person=${id}` : ''}`, formData);
export const getUserFile = (type: string, id: number) => axios.get(`/file/${type}${(id) ? `?iss_person=${id}` : ''}`);

export const getCompanyInfoBySiren = (siren: string) => axios.get(`/company/${siren}`);
export const updateCompanyInfoBySiren = (siren: string, value: Society) => axios.put(`/company/${siren}`, value);
export const createCompanyInfo = (value: Society) => axios.post(`/company`, value);

export const getCompany = () => axios.get('/company');
